import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-lead-distribution-dialog',
  templateUrl: './edit-lead-distribution-dialog.component.html',
  styleUrls: ['./lead-distribution.component.css']
})
export class EditLeadDistributionDialogComponent implements OnInit {
  selectedCounsellor: any;

  constructor(
    public dialogRef: MatDialogRef<EditLeadDistributionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.selectedCounsellor) {
      this.dialogRef.close({ 
        action: 'save', 
        data: { refNo: this.selectedCounsellor }
      });
    }
  }
}
